module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 10
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 1,
      "placeholder": "多个货号之间使用英文逗号 ',' 分隔",
      "clearable": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.item_bns),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bns", $$v)
      },
      expression: "params.item_bns"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-circle-plus-outline"
    },
    on: {
      "click": _vm.showAddItemDialog
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("datetime")(scope.row.created_at, 'yyyy-MM-dd hh:mm:ss')) + "\n              ")]
      }
    }], null, false, 2143355523)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activeList",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.delItems(scope.row.id)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2734960555)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [20, 50, 100, 200, 500],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加禁售商品",
      "width": "40%",
      "visible": _vm.addItemsDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.addItemsDialog = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.form,
        "label-width": "100px"
      }
    }, [_c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品货号"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入商品货号"
      },
      model: {
        value: (_vm.form.item_bn),
        callback: function($$v) {
          _vm.$set(_vm.form, "item_bn", $$v)
        },
        expression: "form.item_bn"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-left",
      attrs: {
        "label": "商品名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入商品名称"
      },
      model: {
        value: (_vm.form.item_name),
        callback: function($$v) {
          _vm.$set(_vm.form, "item_name", $$v)
        },
        expression: "form.item_name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.addItems
      }
    }, [_vm._v("添加")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2879a104", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2879a104"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/disabledgoods/list.vue
// module id = 2559
// module chunks = 0